import { ActionReducer } from '@ngrx/store';

export function errorHandlingMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return (state, action) => {
        try {
            // Invoke the actual reducer function
            return reducer(state, action);
        } catch (error) {
            console.error('Unhandled error in store: ', error);
            // Optionally, return a fallback state or rethrow the error
            // Return previous state if needed to avoid application crash
            return state;
        }
    };
}
